import { subscriptionManagerApiSlice } from "../apiSlice";

export const algorithmInputSlice = subscriptionManagerApiSlice.injectEndpoints({
    endpoints: builder => ({
        putPauseStateCode: builder.mutation({
            query: ({ id }) => ({
                url: `/pause/${id}`,
                method: 'PUT',
            }),
            invalidatesTags: ["Subscription", "Building"],
            transformResponse: (response, meta) => {
                // Access the Location header
                const locationHeader = meta?.response?.headers.get('Location');
                // Return the original response and the extracted ID
                return { data: response, location: locationHeader };
            },
        }),

        putResumeStateCode: builder.mutation({
            query: ({ id }) => ({
                url: `/resume/${id}`,
                method: 'PUT',
            }),
            invalidatesTags: ["Subscription", "Building"],
            transformResponse: (response, meta) => {
                // Access the Location header
                const locationHeader = meta?.response?.headers.get('Location');
                // Return the original response and the extracted ID
                return { data: response, location: locationHeader };
            },
        }),

        putActivateStateCode: builder.mutation({
            query: ({ id }) => ({
                url: `/activate/${id}`,
                method: 'PUT',
            }),
            invalidatesTags: ["Subscription", "Building"],
            transformResponse: (response, meta) => {
                // Access the Location header
                const locationHeader = meta?.response?.headers.get('Location');
                // Return the original response and the extracted ID
                return { data: response, location: locationHeader };
            },
        }),

        putResetInitializationStateCode: builder.mutation({
            query: ({ id }) => ({
                url: `/reset_initialization/${id}`,
                method: 'PUT',
            }),
            invalidatesTags: ["Subscription", "Building"],
            transformResponse: (response, meta) => {
                // Access the Location header
                const locationHeader = meta?.response?.headers.get('Location');
                // Return the original response and the extracted ID
                return { data: response, location: locationHeader };
            },
        }),

        getAlgorithmInputSpecificationByJobType: builder.query({
            query: (args) => {
            const { jobType } = args
                return {
                    url: `/algorithm_inputs_json/${jobType}`,
                }
            },
            transformResponse: (response, meta, arg) => {
                // Assuming the response is a JSON object and needs to be returned as is
                // You can add additional checks or transformations if needed
                return response;
            },
            providesTags: ["AlgorithmInputSpecification"],
        }),

        getAlgorithmInputFormSpecificationByJobType: builder.query({
            query: (args) => {
            const { jobType } = args
                return {
                    url: `/algorithm_inputs_form/${jobType}`,
                }
            },
            transformResponse: (response, meta, arg) => {
                // Assuming the response is a JSON object and needs to be returned as is
                // You can add additional checks or transformations if needed
                return response;
            },
            providesTags: ["AlgorithmInputFormSpecification"],
        }),

        getAlgorithmInputSupportedJobTypes: builder.query({
            query: () => {
                return {
                    url: `/supported_job_types`,
                }
                },
        }),

        postResetPredictiveHeatControl: builder.mutation({
            query: ({jobIdList}) => ({
                url: `/reset_heat_control`,
                method: 'POST',
                body: JSON.stringify(jobIdList)
            }),
            invalidatesTags: ['PredictiveHeatControl']
        }),

        putResetMachineLearning: builder.mutation({
            query: ({jobId, body}) => ({
                url: `/reset_machine_learning/${jobId}`,
                method: 'PUT',
                body: JSON.stringify(body)
            }),
            invalidatesTags: ['PredictiveHeatControl']
        }),

        postSubscribePeoAlarms: builder.mutation({
            query: ({buildingId, body}) => ({
                url: `/subscribe_peo_alarms/${buildingId}`,
                method: 'POST',
                body: JSON.stringify(body)
            }),
            invalidatesTags: ['AlarmSubscription']
        }),

        getSupportedAlarmJobTypes: builder.query({
            query:() =>{
                return {
                    url: `/subscribe_peo_alarms/supported_alarm_job_types`

                }
            },
            providesTags: ["SupportedAlarmJobTypes"]
        }),

        getSupportedPeoJobTypes: builder.query({
            query:() =>{
                return {
                    url: `/subscribe_peo_alarms/supported_peo_job_types`

                }
            },
            providesTags: ["SupportedPeoJobTypes"]
        }),

        getOccupancyPrediction: builder.query({
            query: (args) => {
                const { jobSubscriptionId, start, end } = args
                return {
                    url: `/occupancy_prediction/${jobSubscriptionId}?start_time=${start}&end_time=${end}`,
                }
            },
            providesTags: ["OccupancyPrediction"],
        }),

        getOccupancyPredictionAnalysis: builder.query({
            query: ({ jobSubscriptionId, start, end, duration, filterErraticPredictions, exclusions }) => {
              let url = `/occupancy_prediction/${jobSubscriptionId}?filter_erratic_predictions=${filterErraticPredictions}`;
              
              if (duration !== undefined && duration !== null && duration !== '') {
                url += `&minimum_occupancy_duration=${duration}`;
              }
          
              exclusions.forEach(exclusion => {
                url += `&occupancy_source_exclusion=${exclusion}`;
              });
          
              return { url };
            },
            providesTags: ["OccupancyPrediction"],
          }),
    })
})

export const {
    usePutPauseStateCodeMutation,
    usePutResumeStateCodeMutation,
    usePutActivateStateCodeMutation,
    usePutResetInitializationStateCodeMutation,
    useGetAlgorithmInputSpecificationByJobTypeQuery,
    useLazyGetAlgorithmInputSpecificationByJobTypeQuery,
    useGetAlgorithmInputFormSpecificationByJobTypeQuery,
    useLazyGetAlgorithmInputFormSpecificationByJobTypeQuery,
    useGetAlgorithmInputSupportedJobTypesQuery,
    usePostResetPredictiveHeatControlMutation,
    usePutResetMachineLearningMutation,
    usePostSubscribePeoAlarmsMutation,
    useGetSupportedAlarmJobTypesQuery,
    useGetSupportedPeoJobTypesQuery,
    useGetOccupancyPredictionQuery,
    useLazyGetOccupancyPredictionQuery,
    useGetOccupancyPredictionAnalysisQuery,
    useLazyGetOccupancyPredictionAnalysisQuery

    } = algorithmInputSlice